import type { GlobalState } from '../index';
import type { IState } from '../reducers/productPopupInfo';

export const getProductsSelector = (state: GlobalState): IState['products'] => state.productPopupInfo.products;
export const getProductConfigSelector = (state: GlobalState): IState['productConfig'] =>
  state.productPopupInfo.productConfig;
export const getDictionariesSelector = (state: GlobalState): IState['dictionaries'] =>
  state.productPopupInfo.dictionaries;
